import React, { useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import CardMobileSection from 'components/sales/tableSection/cardMobileSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { STATUS } from 'constants/statusConstant';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
//import './siteListing.css';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import useLatLng from 'hooks/uselatlng/uselatlng';

const SiteAssetMapping = ({
  getSiteListingForAssetMapping,
  siteListData,
  getSiteFilters,
  siteFilters,
  getLocationChange,
  locationChange,
  history
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [cardListData, setCardListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const islatlng = useLatLng();
  const [lat, setLat] = useState('');
  const [long, setLong] = useState('');
  const headers = [
    'Project Id',
    'Business Name',
    'Lead Type',
    'Area',
    'City',
    'Assigned To',
    'Actions',
  ];
  const cardHeaders = [
    'Project Id',
    'Business Name',
    'Lead Type',
    'Area',
    'City',
    'Assigned To',
    'Actions',
  ];
  console.log('PAGE::ASSET MAPPING SITES');
  console.log('function ' + JSON.stringify(islatlng));
    async function fetchAttData() {
        try {
          // fetchAttd
            const url = `${Config.attendance.fetchAttd}`;

            const { data } = await axios.get(url);
            console.log(data.response.data)
            // setData(data?.response?.data);
        } catch {
            console.log('Something went wrong');
        }
    }

  useEffect(() => {
    fetchAttData();
    const installationCont = JSON.parse(
      localStorage.getItem("installationCont") &&
        localStorage.getItem("installationCont")
    );
    if(installationCont){
      localStorage.setItem("installationContractList", JSON.stringify(""));
      localStorage.setItem("installationCont", 0);
    }
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles && setIsRoleId(roles[0].pivot.role_id);
      })();
    }, 0);
  }, []);

  useEffect(() => {
    if(islatlng) {
    const latitude = Number(islatlng?.lat);
    const longitude = Number(islatlng?.lng);
    console.log('lat ' + latitude + 'long ' + longitude);
      if(isNaN(latitude) || isNaN(longitude)) {
        alert(localization.locationPermission);
        return false;
      } else {
        setLat(Number(islatlng?.lat));
        setLong(Number(islatlng?.lng));
      }
    }
  },[islatlng]);

  useEffect(() => {
    if (getSiteListingForAssetMapping !== null && lat != '' && long != '') 
      (async () => {
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("installationContractList") &&
            localStorage.getItem("installationContractList")
        );
        setIsLoading(true);
        if(getcontractFilter){
          await getSiteListingForAssetMapping(getcontractFilter,1,lat,long);
        }else{
          await getSiteListingForAssetMapping(null,1,lat,long);
        }
        setIsLoading(false);
      })();
  }, [getSiteListingForAssetMapping,lat,long]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteFilters();
      setIsLoading(false);
    })();
  }, [getSiteFilters]);

  useEffect(() => {

    const tableData = [
      'id',
      'infra_project_id',
      'client_name',
      'lead_type',
      'area_name',
      'city_name',
      'assigned_to'
    ];
    const cardTableData = [
      'id',
      'infra_project_id',
      'client_name',
      'lead_type',
      'area_name',
      'city_name',
      'assigned_to',
      'Actions'
    ];
    console.log(siteListData);
    if (siteListData && siteListData.data) {
      const cardData = siteListData.data.map((element) =>
        Object.assign(
          {},
          ...cardTableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
            [
                { name: 'Asset Mapping', link: '/dashboard/lead-details' },
            ]
          }
        )
      );
      if (cardData) {
          cardData && setCardListData(cardData);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }

    if (siteListData && siteListData.data) {
      const data = siteListData.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
            [
              { name: 'Solution List', link: '/dashboard/site-gates' },
            ]  
          }
        )
      );
      if (data) {
        data && setListData(data);
      }
      setPageCount(Math.ceil(siteListData.total / siteListData.per_page));
    }
  }, [siteListData, isRoleId]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const redirectToBulkAssignment = () => {
    history.push(`${baseUrl}/bulk-assignment?type=installationContractList`);
  }

  const applyFilter = async (filterData) => {
    localStorage.setItem("installationContractList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getSiteListingForAssetMapping(filterData,1,lat,long);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
        <>
          {/* {isRoleId !== 9 &&
              <Button
                  onClick={redirectToBulkAssignment}
                  className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
              >
                <b className="site_filters" style={{width:"max-content"}}>
                  {localization.bulkAssignment}
                </b>
              </Button>
          } */}
      {/* <Button
        onClick={filterToggle}
        className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
      >
        <img src={Images?.Filter} alt="" />
        <b className="site_filters" style={{width:"max-content"}}>
        {localization.showFilters}
        </b>
      </Button> */}
        </>
    );
  };

  const onPageChange = async (val) => {
  
    let filter = JSON.parse(localStorage.getItem("installationContractList") && localStorage.getItem("installationContractList"));
    setIsLoading(true);
    await getSiteListingForAssetMapping(filterData, val.selected + 1,lat,long);
    setIsLoading(false);
  };

  const updateLocation = (val) => {
    const isLocation = val.check === false ? 0 : 1;
    getLocationChange(val.id, isLocation);
  };

  useEffect(() => {
    (async () => {
      if (locationChange.status) {
        setIsLoading(true);
        await getSiteListingForAssetMapping();
        setIsLoading(false);
      }
    })();
  }, [locationChange]);

  return (
    <Layout
      title={localization.projectList}
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        onChange={(val) => {
          updateLocation(val);
        }}
        detailList={siteListData && siteListData.data}
        srNo={siteListData?.from}
      />
      
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={siteFilters?.site_types ? siteFilters : null}
        siteFilters
      />
    </Layout>
  );
};

export default SiteAssetMapping;
